import React from "react";

import {
  Switch,
  Redirect,
  useRouteMatch,
  useHistory
} from "react-router-dom";

import RoomBooking from '../../../../RoomBooking';

import { RoomBookingRoute } from '../../../../../routes/RoomBookingRoute';

const Routes = () => {
  const history = useHistory();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <RoomBookingRoute path={`${path}/roomBooking/:date?`} render={() => {
        return (
          <RoomBooking
            onClose={() => history.push(`${path}`)}
          />
        )
      }}
      />
      <Redirect to={`${path}`} />
    </Switch>
  );
}

export default Routes;
